export const ORDERSTATUS_OPEN = 'Open';
export const PICK_AND_CHOOSE = 'PICK_AND_CHOOSE';
export const BUNDLE_AND_SAVE = 'BUNDLE_AND_SAVE';
